export const accountEntityRelationships = ['ASSOCIATE', 'OWNER'] as const;

export const accountTypes = ['DESIGNATED', 'LOCAL'] as const;

export const countryCodes = [
	'AD',
	'AE',
	'AF',
	'AG',
	'AI',
	'AL',
	'AM',
	'AO',
	'AQ',
	'AR',
	'AS',
	'AT',
	'AU',
	'AW',
	'AX',
	'AZ',
	'BA',
	'BB',
	'BD',
	'BE',
	'BF',
	'BG',
	'BH',
	'BI',
	'BJ',
	'BL',
	'BM',
	'BN',
	'BO',
	'BQ',
	'BR',
	'BS',
	'BT',
	'BV',
	'BW',
	'BY',
	'BZ',
	'CA',
	'CC',
	'CD',
	'CF',
	'CG',
	'CH',
	'CI',
	'CK',
	'CL',
	'CM',
	'CN',
	'CO',
	'CR',
	'CU',
	'CV',
	'CW',
	'CX',
	'CY',
	'CZ',
	'DE',
	'DJ',
	'DK',
	'DM',
	'DO',
	'DZ',
	'EC',
	'EE',
	'EG',
	'EH',
	'ER',
	'ES',
	'ET',
	'FI',
	'FJ',
	'FK',
	'FM',
	'FO',
	'FR',
	'GA',
	'GB',
	'GD',
	'GE',
	'GF',
	'GG',
	'GH',
	'GI',
	'GL',
	'GM',
	'GN',
	'GP',
	'GQ',
	'GR',
	'GS',
	'GT',
	'GU',
	'GW',
	'GY',
	'HK',
	'HM',
	'HN',
	'HR',
	'HT',
	'HU',
	'ID',
	'IE',
	'IL',
	'IM',
	'IN',
	'IO',
	'IQ',
	'IR',
	'IS',
	'IT',
	'JE',
	'JM',
	'JO',
	'JP',
	'KE',
	'KG',
	'KH',
	'KI',
	'KM',
	'KN',
	'KP',
	'KR',
	'KW',
	'KY',
	'KZ',
	'LA',
	'LB',
	'LC',
	'LI',
	'LK',
	'LR',
	'LS',
	'LT',
	'LU',
	'LV',
	'LY',
	'MA',
	'MC',
	'MD',
	'ME',
	'MF',
	'MG',
	'MH',
	'MK',
	'ML',
	'MM',
	'MN',
	'MO',
	'MP',
	'MQ',
	'MR',
	'MS',
	'MT',
	'MU',
	'MV',
	'MW',
	'MX',
	'MY',
	'MZ',
	'NA',
	'NC',
	'NE',
	'NF',
	'NG',
	'NI',
	'NL',
	'NO',
	'NP',
	'NR',
	'NU',
	'NZ',
	'OM',
	'PA',
	'PE',
	'PF',
	'PG',
	'PH',
	'PK',
	'PL',
	'PM',
	'PN',
	'PR',
	'PS',
	'PT',
	'PW',
	'PY',
	'QA',
	'RE',
	'RO',
	'RS',
	'RU',
	'RW',
	'SA',
	'SB',
	'SC',
	'SD',
	'SE',
	'SG',
	'SH',
	'SI',
	'SJ',
	'SK',
	'SL',
	'SM',
	'SN',
	'SO',
	'SR',
	'SS',
	'ST',
	'SV',
	'SX',
	'SY',
	'SZ',
	'TC',
	'TD',
	'TF',
	'TG',
	'TH',
	'TJ',
	'TK',
	'TL',
	'TM',
	'TN',
	'TO',
	'TR',
	'TT',
	'TV',
	'TW',
	'TZ',
	'UA',
	'UG',
	'UM',
	'US',
	'UY',
	'UZ',
	'VA',
	'VC',
	'VE',
	'VG',
	'VI',
	'VN',
	'VU',
	'WF',
	'WS',
	'XK',
	'YE',
	'YT',
	'ZA',
	'ZM',
	'ZW',
] as const;

export const documentCategories = ['HISTORICAL_TRANSACTIONS', 'IDENTIFICATION', 'LICENSE'] as const;

export const entitySubtypes = ['INDIVIDUAL', 'ORGANIZATION'] as const;

export const entityTypesDefault = ['INTERMEDIARY', 'PIU', 'SUB_PIU'] as const;

export const entityTypesExt = ['BENEFICIARY', 'SUPPLIER'] as const;

export const entityTypesReadOnly = ['AUDITOR', 'BORROWER', 'DONOR', 'TAX_AUTHORITY'] as const;

export const entityTypes = [
	...entityTypesExt,
	...entityTypesReadOnly,
	...entityTypesDefault,
] as const;

export const errorIds = ['LOGIN_INVALID_OTP', 'LOGIN_USER_NOT_FOUND'] as const;

export const featureFlags = ['CONTRACT_WORKFLOW'] as const;

export const flagCodes = ['EU'] as const;

export const financiersWbg = ['COFN', 'IBRD', 'IDA', 'TF'] as const;
export const financiersExt = ['GOV', 'OTH'] as const;
export const financiers = [...financiersWbg, ...financiersExt] as const;

export const financingSources = ['LOAN', 'GOVERNMENT', 'OTHER'] as const;

export const actionStatuses = ['DEFAULT', 'EDITING', 'ERROR', 'LOADING', 'SUCCESS'] as const;

export const contractStatuses = [
	'ACTIVE',
	'CANCELLED',
	'COMPLETED',
	'DEACTIVATED',
	'DELETED',
	'DRAFT',
	'SUBMITTED',
] as const;

export const invoiceStatuses = [
	'APPROVED',
	'DEACTIVATED',
	'DRAFT',
	'ON_HOLD',
	'PAID',
	'PAYMENT_IN_PROGRESS',
	'PENDING_PAYMENT',
	'PENDING_REVIEW',
	'READY_FOR_PAYMENT',
	'REJECTED',
] as const;

export const loanStatuses = ['DISABLED', 'ENABLED'] as const;

export const loginTypes = ['email', 'sms'] as const;

export const traceabilityTypes = ['FINANCIAL', 'TRANSACTIONS'] as const;

export const transactionStatuses = ['COMPLETED', 'FAILED', 'IN_PROGRESS', 'WAITING'] as const;

export const transactionTypes = [
	'ADVANCE',
	'CASH_BENEFIT',
	'DIRECT',
	'INITIAL',
	'NON_CASH_BENEFIT',
	'OPEX',
	'PAYMENT',
	'REIMBURSEMENT',
	'REPLENISHMENT',
	'TRANSFER',
] as const;

export const userRoles = ['GENERAL', 'LIAISON', 'STAFF', 'TTL', 'WFA'] as const;

export const userStatuses = ['ACTIVE', 'CREATED', 'DEACTIVATED', 'INVITED'] as const;
